'use strict';

export default [
  'AuthService', '$rootScope',
  class ForgotPasswordController {
    constructor(authService, $rootScope) {
      this._authService = authService;
      this._$rootScope = $rootScope;
      this.passwordRetrieved = false;
      this.submitState = 'test';
    }

    retrieve() {
      this.submitState = 'loading';
      this.passwordRetrieved = false;
      this._authService.resetPasswordRequest(this.email)
        .then((res) => this.retrieveSuccess(res))
        .catch((err) => this.retrieveFailed(err));
    }

    close() {
      this.toggle = false;
      this._$rootScope.$broadcast('login:open', {});
    }

    retrieveSuccess(res) {
      this.submitState = 'success';
      this.toggle = false;
      this.email = '';
      this.forgotPassword.$setPristine();
      this.passwordRetrieved = true;
    }

    retrieveFailed(err) {
      this.submitState = 'error';
      this.passwordRetrieved = false;
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/account/forgot-password/forgot-password.ctrl.js